import React from 'react';

import { useFormikContext } from 'formik';

import { camelToSpaceCase, ia } from 'lib/helpers/utility';

import Checkbox from 'components/shared/Checkbox/Checkbox';
import SegmentedControl from 'components/shared/SegmentedControl/SegmentedControl';

const options = [
  {
    label: 'All',
    value: 'all'
  },
  {
    label: 'Custom',
    value: 'custom'
  }
];

const ColumnCheckboxList = ({ columns, selectedFieldName, selected, setFieldValue, qaPrefix }) => (
  <div className="grid grid-cols-2 gap-4">
    {columns?.map((option, idx) => {
      const value = option?.field;
      const isChecked = selected?.includes(value);

      return (
        <Checkbox
          key={idx}
          data-qa={`${qaPrefix}-${value}`}
          isChecked={isChecked}
          handleClick={() => {
            const newValues = selected?.includes(value)
              ? selected.filter((val) => val !== value)
              : [...(selected || []), value];

            setFieldValue(selectedFieldName, newValues);
          }}
          label={option?.headerName || camelToSpaceCase(value)}
        />
      );
    })}
  </div>
);

const ExportColumnsCheckbox = () => {
  const { values, setFieldValue, columns, parentColumns, childColumns } = useFormikContext();

  const isCustom = values?.export_columns?.includes('custom');
  const showSplitSections =
    isCustom && values?.export_data === 'detailed' && ia(childColumns) && ia(parentColumns);

  return (
    <div>
      <label className="m-0 text-sm font-500 text-neutral-800 first-letter:capitalize">
        Export Columns
        <span className="text-danger-400">*</span>
      </label>

      <div className="mt-2">
        <SegmentedControl
          active={values?.export_columns?.[0]}
          className="!w-auto"
          onClick={(item) => setFieldValue('export_columns', [item.value])}
          items={options}
        />
      </div>

      {isCustom && showSplitSections && (
        <div className="mt-4 flex flex-col gap-4">
          <div>
            <label className="m-0 text-xs font-500 text-neutral-700 first-letter:capitalize">
              Parent Columns
            </label>
            <div className="mt-2">
              <ColumnCheckboxList
                columns={parentColumns}
                selectedFieldName="selected_parent_columns"
                selected={values?.selected_parent_columns}
                setFieldValue={setFieldValue}
                qaPrefix="checkbox-parent"
              />
            </div>
          </div>

          <div>
            <label className="m-0 text-xs font-500 text-neutral-700 first-letter:capitalize">
              Child Columns
            </label>
            <div className="mt-2">
              <ColumnCheckboxList
                columns={childColumns}
                selectedFieldName="selected_columns"
                selected={values?.selected_columns}
                setFieldValue={setFieldValue}
                qaPrefix="checkbox-child"
              />
            </div>
          </div>
        </div>
      )}

      {isCustom && !showSplitSections && (
        <div className="mt-4">
          <ColumnCheckboxList
            columns={columns}
            selectedFieldName="selected_columns"
            selected={values?.selected_columns}
            setFieldValue={setFieldValue}
            qaPrefix="checkbox"
          />
        </div>
      )}
    </div>
  );
};

export default ExportColumnsCheckbox;
